import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listTrips, type Trip } from '../api/trips';

export function TripsPage() {
  const [trips, setTrips] = useState<Trip[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listTrips()
      .then(setTrips)
      .catch((e) => setError(e.message ?? 'Errore caricamento viaggi'));
  }, []);

  return (
    <div className="page">
      <div className="page-head">
        <h1>I miei viaggi</h1>
        <Link to="/trips/new" className="btn btn-primary">
          + Nuovo viaggio
        </Link>
      </div>

      {error && <p className="err">{error}</p>}

      {!error && trips === null && <p className="muted">Caricamento…</p>}

      {trips && trips.length === 0 && (
        <div className="empty-state">
          <p>Nessun viaggio ancora. Inizia creandone uno.</p>
        </div>
      )}

      {trips && trips.length > 0 && (
        <ul className="trip-list">
          {trips.map((t) => (
            <li key={t.id}>
              <Link to={`/trips/${t.id}`} className="trip-card">
                <h2 className="cd-title-upper">{t.title}</h2>
                {(t.startDate || t.endDate) && (
                  <p className="dates">
                    {t.startDate ? formatDate(t.startDate) : '—'} →{' '}
                    {t.endDate ? formatDate(t.endDate) : '—'}
                  </p>
                )}
                {t.description && <p className="desc">{t.description}</p>}
                <p className="counts">
                  <span>{t.stagesCount} tappe</span>
                  <span>·</span>
                  <span>{t.postsCount} post</span>
                  <span>·</span>
                  <span>{t.photosCount} foto</span>
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
